<template>
  <span class="saving-loader">
    <span class="spinner">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.80051 3.5H2.51651C3.33274 2.34722 4.56436 1.7 6.00043 1.7C8.65121 1.7 10.8001 3.84903 10.8001 6.5H12C12 3.18629 9.3139 0.5 6.00043 0.5C4.31801 0.5 2.83572 1.20951 1.80073 2.46221V0.5H0.600811V4.7H4.80051V3.5ZM7.19949 9.5H9.48349C8.66726 10.6528 7.43565 11.3 5.99958 11.3C3.3488 11.3 1.19992 9.15097 1.19992 6.5H0C0 9.81371 2.6861 12.5 5.99958 12.5C7.682 12.5 9.16429 11.7905 10.1993 10.5378V12.5H11.3992V8.3H7.19949V9.5Z"
          :fill="iconColor"
        />
      </svg>
    </span>

    <span class="pl-2">Saving..</span>
  </span>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      required: false,
      default: "White",
    },
  },
};
</script>

<style scoped>
.saving-loader {
  display: flex;
  align-items: center;
}
.spinner svg {
  animation: roll 1s linear infinite;
}
@keyframes roll {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
